import React from 'react';
import { renderPolling } from '../utils';

export type Props = {
  defaultEndpage: React.ReactElement;
  pollingTreatment: string;
  pollingExperiment: string;
};

export default function PollingEndpage({
  defaultEndpage,
  pollingTreatment,
  pollingExperiment,
}: Props): React.ReactElement {
  return <>{renderPolling(defaultEndpage, pollingTreatment, pollingExperiment)}</>;
}
